export function sortItems<T>(items: T[], sort: { [key: string]: 'asc' | 'desc' } | null, locale = 'en'): void {
  if (!sort) {
    return;
  }

  const collator = new Intl.Collator(locale, { sensitivity: 'base' }); // better performance than localeCompare for large lists

  items.sort((a, b) => {
    for (const [key, direction] of Object.entries(sort)) {
      const aValue = (a as any)[key];
      const bValue = (b as any)[key];

      if (typeof aValue === 'string' && typeof bValue === 'string') {
        const result = collator.compare(aValue, bValue);
        if (result !== 0) return direction === 'asc' ? result : -result;
      } else {
        if (aValue < bValue) return direction === 'asc' ? -1 : 1;
        if (aValue > bValue) return direction === 'asc' ? 1 : -1;
      }
    }

    return 0;
  });
}
